import React, {Component, Fragment} from 'react';
import moment from 'moment';
import {Grid} from '@material-ui/core';
import createLoyaltyDealerRefundOrderMutation from 'graphql/mutations/orders/create-loyalty-dealer-refund-order.gql';
import SectionBanner from 'components/section-banner';
import {Form, Field, Input, DateInput} from 'components/forms';
import {gt} from 'components/forms/form/validators';
import Button from 'components/button';
import {refundForm} from 'components/forms/decorators';
import styles from './styles.css';

@refundForm(createLoyaltyDealerRefundOrderMutation)
export default class LoyaltyRefundCreate extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <Form
                    fields={[
                        {key: 'estimatedAmount', validators: [gt(0)]},
                        {key: 'destination'},
                        {key: 'dateFrom'},
                        {key: 'dateTo'},
                    ]}
                    errors={this.props.errors}
                    onSubmit={this.props.onSubmit}>
                    {({getFieldProps, renderErrors, isValid}) => (
                        <Fragment>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Field label='Presupuesto estimado en pesos'>
                                        <Input type='number' {...getFieldProps('estimatedAmount')} />
                                        {renderErrors('estimatedAmount')}
                                    </Field>
                                </Grid>
                                <Grid item xs={12}>
                                    <Field label='Destino'>
                                        <Input type='text' {...getFieldProps('destination')} />
                                        {renderErrors('destination')}
                                    </Field>
                                </Grid>
                                <Grid item xs={6}>
                                    <Field label='Fecha desde'>
                                        <DateInput {...getFieldProps('dateFrom')} />
                                        {renderErrors('dateFrom')}
                                    </Field>
                                </Grid>
                                <Grid item xs={6}>
                                    <Field label='Fecha hasta'>
                                        <DateInput {...getFieldProps('dateTo')} />
                                        {renderErrors('dateTo')}
                                    </Field>
                                </Grid>
                                {renderErrors('__all__')}
                                <Grid item xs={12}>
                                    <Form.Actions>
                                        <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                            {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                        </Button>
                                    </Form.Actions>
                                </Grid>
                            </Grid>
                        </Fragment>
                    )}
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/loyalty/index.js